// SPDX-FileCopyrightText: 2026 Stadtplatz.de
//
// SPDX-License-Identifier: EUPL-1.2

/**
 * Runtime environment variable utility
 * Cross-platform compatible (Windows/Ubuntu/Linux)
 *
 * Reads from window._env (set by config.js at runtime via Jenkins env file)
 * Falls back to process.env for development/local builds
 */
const getEnvVar = (key) => {
  // In production/runtime, use config from window._env (set by config.js generated from Jenkins env file)
  if (typeof window !== "undefined" && window._env) {
    const value = window._env[key];
    if (value !== undefined && value !== null && value !== "") {
      return value;
    }
  }

  // Fallback to process.env for development/local builds (Create React App)
  // This works on both Windows and Unix-like systems
  return process.env[key];
};

export const env = {
  REACT_APP_API_BASE_URL: getEnvVar("REACT_APP_API_BASE_URL"),
  REACT_APP_APP_NAME: getEnvVar("REACT_APP_APP_NAME"),
  REACT_APP_VERSION: getEnvVar("REACT_APP_VERSION"),
  REACT_APP_KEYCLOAK_URL: getEnvVar("REACT_APP_KEYCLOAK_URL"),
  REACT_APP_KEYCLOAK_REALM: getEnvVar("REACT_APP_KEYCLOAK_REALM"),
  REACT_APP_KEYCLOAK_CLIENT_ID: getEnvVar("REACT_APP_KEYCLOAK_CLIENT_ID"),
  REACT_APP_API_HOME_URL: getEnvVar("REACT_APP_API_HOME_URL"),
};

export default env;
